<template>
  <v-container style="max-width:800px">
    <h2 class="text-center">{{ founder.title }}</h2>
    <br/>
    <div class="d-flex flex-wrap">
      <v-col class="py-3">
        <div class="d-flex justify-center">
          <div class="us-container">
            <div class="shadow">
              <div class="d-flex justify-end align-end" style="height:100%" v-if="!noRedirect">
                <v-btn text color="white" :to="{path: '/qui-sommes-nous'}">
                  <v-icon color="white">mdi-play</v-icon> {{ founder.more2action }}
                </v-btn>
              </div>
            </div>
            
            <v-img 
            :src="founder.src"
            :lazy-src="founder.srcLazy"
            :style="{width: $vuetify.breakpoint.mdAndUp ? '450px' : '100%'}"
            max-height="320px"
            contain
            />
          </div>
        </div>
      </v-col>
      <v-col class="d-flex flex-column justify-center align-center pa-5 my-2">
        <p v-html="founder.text"></p>
        <v-btn rounded color="#ef6758" style="color:white" :to="{path: '/nos-offres'}">
          {{ call2action }}
        </v-btn>
      </v-col>
    </div>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    noRedirect: Boolean
  },
  computed: {
    ...mapGetters('strapiv2', ['founder', 'call2action'])
  }
}
</script>

<style scoped>
.shadow {
  position: absolute;
  background-color: #ef6758;
  bottom: -30px;
  left: -30px;
  width: 450px;
  height: 250px;
}

.us-container {
  position:relative;
  height:320px;
  width:450px;
}

.more-us {
  position: absolute;
  bottom: -16px;
  left: -35px;
  width: 450px;
  height: 1.1em;
  font-size: 1em;
  text-align: right;
  color: white;
}

@media (max-width: 450px) {
  .more-us {
    bottom: -16px;
    width: 100%;
  }
  .us-container {
    width: 100%;
  }
  .shadow {
    top: 25px;
    left: 0;
    width: 100%;
    height: 250px;
  }
}

@media (min-width: 600px) {
  .fab-project {
    width:140px;
    height:140px;
    font-size:20px;
  }
}

h2 {
  /* text-align: center; */
  /* color: #0b755f; */
}
p {
  text-align: center;
  color:#3E524F;
}
</style>